/* Vitalia home — interactions (no dependencies, safe to load several times).
   Reveal on scroll, count-up, parallax, sticky header + progress bar, search,
   mobile drawer, rails, video lightbox, AJAX add to cart, cart count, buy bar. */
(function () {
  if (window.__vhLoaded) return;
  window.__vhLoaded = true;
  document.documentElement.classList.add('vh-js');

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- Reveal + count-up ---------- */
  function count(n) {
    if (n.dataset.done) return;
    n.dataset.done = '1';
    var to = parseFloat(n.dataset.vhCount) || 0;
    var suf = n.dataset.suffix || '';
    var sep = n.dataset.sep === undefined ? ' ' : n.dataset.sep;
    var fmt = function (v) { return String(Math.round(v)).replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
    if (reduce) { n.textContent = fmt(to) + suf; return; }
    var t0 = performance.now();
    (function step(t) {
      var p = Math.min(1, (t - t0) / 1100);
      n.textContent = fmt(to * (1 - Math.pow(1 - p, 3))) + suf;
      if (p < 1) requestAnimationFrame(step);
    })(t0);
  }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      var sibs = el.parentElement ? Array.prototype.filter.call(el.parentElement.children, function (c) { return c.hasAttribute('data-vh-reveal'); }) : [];
      el.style.transitionDelay = Math.min(Math.max(0, sibs.indexOf(el)), 7) * 70 + 'ms';
      el.classList.add('is-in');
      io.unobserve(el);
      if (el.hasAttribute('data-vh-count')) count(el);
      el.querySelectorAll('[data-vh-count]').forEach(count);
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' }) : null;

  function initReveal(scope) {
    scope.querySelectorAll('[data-vh-reveal]:not(.is-in)').forEach(function (el) {
      if (!io || reduce || el.closest('.vh-noanim')) { el.classList.add('is-in'); el.querySelectorAll('[data-vh-count]').forEach(count); if (el.hasAttribute('data-vh-count')) count(el); return; }
      io.observe(el);
    });
    scope.querySelectorAll('[data-vh-count]').forEach(function (n) {
      if (!n.closest('[data-vh-reveal]') && io) io.observe(n);
    });
  }

  /* ---------- Scroll-driven: header, progress, parallax, buy bar ----------
     Horizon scrolls an inner .page-wrapper, not the window, so find the real
     scroll container before reading any position. */
  var scroller = null;
  function findScroller() {
    var el = document.querySelector('.page-wrapper');
    if (el && el.scrollHeight > el.clientHeight + 1) {
      var ov = getComputedStyle(el).overflowY;
      if (ov === 'auto' || ov === 'scroll') return el;
    }
    return null;
  }
  function sy() { return scroller ? scroller.scrollTop : (window.scrollY || document.documentElement.scrollTop || 0); }
  function smax() {
    return scroller
      ? scroller.scrollHeight - scroller.clientHeight
      : document.documentElement.scrollHeight - window.innerHeight;
  }

  var raf = 0;
  function tick() {
    raf = 0;
    var y = sy();
    document.querySelectorAll('[data-vh-header]').forEach(function (h) { h.classList.toggle('is-scrolled', y > 10); });
    document.querySelectorAll('[data-vh-progress]').forEach(function (p) {
      var h = smax();
      p.style.width = (h > 0 ? Math.min(100, (y / h) * 100) : 0) + '%';
    });
    if (!reduce) {
      document.querySelectorAll('[data-vh-parallax]').forEach(function (el) {
        var k = parseFloat(el.dataset.vhParallax) || 0;
        if (!k) return;
        var b = el.getBoundingClientRect();
        var d = b.top + b.height / 2 - window.innerHeight / 2;
        el.style.transform = 'translate3d(0,' + (-d * k).toFixed(1) + 'px,0)';
      });
    }
    document.querySelectorAll('[data-vh-buybar]').forEach(function (bar) {
      var hero = document.querySelector('[data-vh-hero]');
      var passed = hero ? hero.getBoundingClientRect().bottom < (scroller ? scroller.clientHeight : window.innerHeight) * 0.25 : y > 600;
      bar.classList.toggle('is-visible', passed);
    });
  }
  function onScroll() { if (!raf) raf = requestAnimationFrame(tick); }
  /* Capture catches scroll events from the inner scroll container too. */
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { scroller = findScroller(); onScroll(); });

  /* ---------- Clicks (delegated) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var sBtn = t.closest('[data-vh-search-toggle]');
    if (sBtn) {
      var box = document.querySelector('[data-vh-search]');
      if (box) {
        var open = !box.classList.contains('is-open');
        box.classList.toggle('is-open', open);
        sBtn.setAttribute('aria-expanded', open);
        if (open) setTimeout(function () { var i = box.querySelector('input'); if (i) i.focus(); }, 260);
      }
      return;
    }

    var nOpen = t.closest('[data-vh-drawer-open]');
    if (nOpen) { toggleDrawer(true); return; }
    if (t.closest('[data-vh-drawer-close]')) { toggleDrawer(false); return; }
    if (t.closest('[data-vh-drawer] a')) toggleDrawer(false);

    var trig = t.closest('[data-vh-menu-toggle]');
    if (trig) {
      var item = trig.closest('.vh-nav__item');
      var isOpen = item.classList.toggle('is-open');
      trig.setAttribute('aria-expanded', isOpen);
      return;
    }
    document.querySelectorAll('.vh-nav__item.is-open').forEach(function (i) { if (!i.contains(t)) i.classList.remove('is-open'); });

    var tab = t.closest('[data-vh-tab]');
    if (tab) {
      var wrap = tab.closest('.vh-mega');
      if (wrap) {
        wrap.querySelectorAll('[data-vh-tab]').forEach(function (b) {
          var on = b === tab;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on);
        });
        wrap.querySelectorAll('.vh-mega__panel').forEach(function (p) {
          p.classList.toggle('is-active', p.id === tab.dataset.vhTab);
        });
      }
      return;
    }

    var rb = t.closest('[data-vh-rail-btn]');
    if (rb) {
      var rail = document.getElementById(rb.dataset.vhRailBtn);
      if (rail) {
        var card = rail.firstElementChild;
        var gap = parseFloat(getComputedStyle(rail).columnGap) || 24;
        var w = (card ? card.getBoundingClientRect().width : 280) + gap;
        rail.scrollBy({ left: rb.dataset.dir === 'next' ? w : -w, behavior: reduce ? 'auto' : 'smooth' });
      }
      return;
    }

    var vb = t.closest('[data-vh-video]');
    if (vb) {
      var dlg = document.getElementById(vb.dataset.vhVideo);
      if (dlg) {
        e.preventDefault();
        var slot = dlg.querySelector('[data-vh-video-slot]');
        var tpl = dlg.querySelector('template');
        if (slot && tpl && !slot.firstElementChild) slot.appendChild(tpl.content.cloneNode(true));
        if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
        var vid = dlg.querySelector('video'); if (vid) { var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
      }
      return;
    }
    var vc = t.closest('[data-vh-video-close]') || (t.matches && t.matches('dialog.vh-modal') ? t : null);
    if (vc) {
      var d = vc.closest('dialog') || vc;
      var s = d.querySelector('[data-vh-video-slot]'); if (s) s.innerHTML = '';
      if (d.close) d.close(); else d.removeAttribute('open');
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    toggleDrawer(false);
    document.querySelectorAll('.vh-nav__item.is-open').forEach(function (i) { i.classList.remove('is-open'); });
  });
  document.addEventListener('close', function (e) {
    if (e.target.matches && e.target.matches('dialog.vh-modal')) { var s = e.target.querySelector('[data-vh-video-slot]'); if (s) s.innerHTML = ''; }
  }, true);

  function toggleDrawer(show) {
    var d = document.querySelector('[data-vh-drawer]');
    if (!d) return;
    if (!show && !d.classList.contains('is-open')) return;
    d.classList.toggle('is-open', show);
    d.setAttribute('aria-hidden', show ? 'false' : 'true');
    document.documentElement.classList.toggle('vh-locked', show);
    var b = document.querySelector('[data-vh-drawer-open]'); if (b) b.setAttribute('aria-expanded', show);
  }

  /* ---------- Cart ---------- */
  function refreshCount() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-vh-cart-count]').forEach(function (n) {
          n.textContent = c.item_count;
          n.hidden = c.item_count === 0;
          if (n.animate && !reduce) n.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.5)' }, { transform: 'scale(1)' }], { duration: 340 });
        });
      }).catch(function () {});
  }
  document.addEventListener('vt:cart:added', refreshCount);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('[data-vh-atc]') || !window.fetch) return;
    e.preventDefault();
    var btn = f.querySelector('[type="submit"]');
    if (btn) btn.classList.add('is-loading');
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok || res.d.status) { alert(res.d.description || res.d.message || 'Erreur'); return; }
        var host = f.closest('[data-vh-after]');
        var go = f.dataset.after || (host ? host.dataset.vhAfter : 'count');
        if (go === 'cart') { window.location.href = root + 'cart'; return; }
        if (go === 'checkout') { window.location.href = root + 'checkout'; return; }
        refreshCount();
        if (btn) { var old = btn.textContent; btn.textContent = btn.dataset.added || '✓'; setTimeout(function () { btn.textContent = old; }, 1600); }
      })
      .catch(function () { f.submit(); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  });

  /* ---------- CMYK pointer lean ---------- */
  function initLean() {
    if (reduce || !window.matchMedia || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (!document.querySelector('.vh-cmyk.is-printed')) return;
    var r2 = 0, x = 0, y = 0;
    window.addEventListener('pointermove', function (e) {
      x = (e.clientX / window.innerWidth) * 2 - 1;
      y = (e.clientY / window.innerHeight) * 2 - 1;
      if (r2) return;
      r2 = requestAnimationFrame(function () {
        r2 = 0;
        document.documentElement.style.setProperty('--press-nx', x.toFixed(3));
        document.documentElement.style.setProperty('--press-ny', y.toFixed(3));
      });
    }, { passive: true });
  }

  function boot() { scroller = findScroller(); initReveal(document); tick(); initLean(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { scroller = findScroller(); initReveal(e.target); tick(); });
})();
